import { DateTime } from "luxon";
import * as Yup from "yup";

import { urgencies } from "@/app/maintenance/maintenance";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const accountingFilterInitialValues = {
  task: "",
  observation: "",
  days: [],
  startDate: undefined,
  endDate: undefined,
  assignedId: undefined,
  urgency: undefined,
  inventoryItemIds: [],
};

export const maintenanceValidationSchema = Yup.object({
  task: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  observation: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  days: Yup.array().min(1, FIELD_REQUIRED_MESSAGE),
  startDate: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  endDate: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  assignedId: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  urgency: Yup.number().oneOf(urgencies.map((urgency) => urgency.id)),
  inventoryItemIds: Yup.array().min(1, FIELD_REQUIRED_MESSAGE),
});

export type MaintenanceValues = typeof accountingFilterInitialValues;

export const transactionInitialValues = {
  name: "",
  description: "",
  amount: 0,
  currency: undefined,
  client: "",
  taxId: "",
  paymentMethod: "",
  type: "sponsorship",
};

export const transactionValidationSchema = Yup.object({
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  description: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  amount: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  currency: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  client: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  taxId: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  paymentMethod: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  type: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export type TransactionValues = typeof transactionInitialValues;

export const billInitialValues = {
  date: DateTime.now().toFormat("yyyy-MM-dd"),
  time: DateTime.now().toFormat("HH:mm"),
  subject: "",
  amount: 0,
  currency: "",
  selledBy: "",
  approvedBy: "",
  subcategory: null,
  invoice: null,
  xml: null,
  description: "",
};

export const billValidationSchema = Yup.object({
  date: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  time: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  subject: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  amount: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  currency: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  selledBy: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  approvedBy: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  subcategory: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export type BillValues = typeof billInitialValues;


export const xmlInitialValues = {
  creditorName: "",
  creditorIban: "",
  creditorAgent: "",
  creditorId: "",
};

export const xmlValidationSchema = Yup.object({
  creditorName: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  creditorIban: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  creditorAgent: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  creditorId: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export type XMLValues = typeof xmlInitialValues;


export const xmlImportInitialValues = {
  date: "",
  time: "",
  file: null,
};

export const xmlImportValidationSchema = Yup.object({
  date: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  time: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  file: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export type XMLImportValues = typeof xmlImportInitialValues;
